export const isEqual = (value1: any, value2: any): boolean => {
  if (typeof value1 !== typeof value2) return false;
  if (value1 === value2) return true;

  return JSON.stringify(value1) === JSON.stringify(value2);
};
